import React, { useState, useEffect, useMemo } from 'react';
import MainContainer from '../../../components/MainContainer';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TableBody, TableCell, TableContainer, TableRow, TextField, Table, Alert, Chip, Autocomplete, Tabs, Tab, Skeleton, IconButton, Typography } from '@mui/material';
import { headerDataMission } from '../../../data/modules/mission-header';
import { Grid } from '@material-ui/core';
import MissionSummaryService from '../../../services/MissionSummaryService';
import { useNavigate, useParams } from 'react-router';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import AddIcon from '@mui/icons-material/Add';
import { TabContext, TabPanel } from '@mui/lab';
import DestinationViewDialog from '../Timesheet/DestinationViewDialog';
import MissionData from '../Timesheet/MissionData';
import RentManagement from '../Timesheet/RentManagement';
import { formatDate } from '../../../helpers/FormateDate';
import { countNightsMission } from '../../../helpers/TimesheetNightHelper';
import DecompteMissionService from '../../../services/DecompteMissionService';
import MissionRentService from '../../../services/MissionRentService';
import MissionTransportService from '../../../services/MissionTransportService';
import Bullred from '../../../components/reusable/Bullred';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import decompteUseStyles from '../../../styles/DecompteMission.style';
import TransportData from '../fuel/TransportData';
import SuccesDialog from '../../../components/reusable/SuccesDialog';
import ErrorDialog from '../../../components/reusable/ErrorDialog';

const normalizeTransportId = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const normalizeDateForPayload = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const rawValue = String(value).trim();
  const match = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
  if (!match) {
    return rawValue;
  }

  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (
    date.getFullYear() !== Number(year)
    || date.getMonth() !== Number(month) - 1
    || date.getDate() !== Number(day)
  ) {
    return rawValue;
  }

  return `${year}-${month}-${day}`;
};

const getTransportIdsFromDestination = (destination = {}) => {
  const directTransportId = normalizeTransportId(destination?.transport_id);
  const nestedTransportIds = Array.isArray(destination?.transports)
    ? destination.transports
        .map((transport) => normalizeTransportId(transport?.transport_id))
        .filter(Boolean)
    : [];

  const ids = new Set();
  if (directTransportId) {
    ids.add(directTransportId);
  }
  nestedTransportIds.forEach((id) => ids.add(id));
  return Array.from(ids);
};

const getPrimaryTransportIdFromDestination = (destination = {}) => {
  const ids = getTransportIdsFromDestination(destination);
  return ids.length ? ids[0] : null;
};

const isWithoutTransport = (destination = {}) =>
  getTransportIdsFromDestination(destination).length === 0;

const buildDestinationUniqueKey = (destination = {}, fallbackIndex = 0) => {
  if (destination?.mission_decompte_detail_id) {
    return `decompte:${destination.mission_decompte_detail_id}`;
  }
  if (destination?.client_row_id) {
    return `manual:${destination.client_row_id}`;
  }
  const transportKey = getPrimaryTransportIdFromDestination(destination) || 0;
  const timesheetDestinationId = destination?.mission_timesheet_destination_id || null;
  const missionDestinationId = destination?.mission_destination_id || null;

  if (timesheetDestinationId) {
    return `${transportKey}:ts:${timesheetDestinationId}`;
  }
  if (missionDestinationId) {
    return `${transportKey}:md:${missionDestinationId}`;
  }
  return `${transportKey}:idx:${fallbackIndex}`;
};

const DecompteAdd = () => {
  const { mission_planning_id, timesheet_id, agenda_id, transport_id } = useParams();
  const navigate = useNavigate();
  const decompteId = useMemo(() => normalizeTransportId(
    new URLSearchParams(window.location.search).get('decompte_id')
  ), []);
  const classes = decompteUseStyles();
  const [mission, setMission] = useState(null);
  const [loadingBackdrop, setLoadingBackdrop] = useState(false);
  const [agendas, setAgendas] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [value, setValue] = useState('1');
  const [missionnaries, setMissionnaries] = useState([]);
  const [transports, setTransports] = useState([]);
  const [resultDialog, setResultDialog] = useState({ open: false, type: '', message: '', redirect: false });
  const [transportDetailDialog, setTransportDetailDialog] = useState({ open: false, transport: null });
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    mission_planning_id: mission_planning_id || null,
    agenda_id: agenda_id || null,
    timesheet_id: timesheet_id || null,
    transport_id: transport_id || null,
    mission_decompte_id: null,
  });
  const [removeDialog, setRemoveDialog] = useState({
    open: false,
    agenda_id: null,
    mission_destination_id: null,
    mission_timesheet_destination_id: null,
  });
  const [sendLoading, setSendLoading] = useState(false);
  const [sendDisabled, setSendDisabled] = useState(false);
  const [transportMeans, setTransportMeans] = useState( [
    { label: 'Voiture FID', value: 'FID', mission_rent_id: null, rent_upfuel: null, rent_amount: null, rent_paiement: null, rent_conso_100km: null },
    { label: 'Avion', value: 'AVION', mission_rent_id: null, rent_upfuel: null, rent_amount: null, rent_paiement: null, rent_conso_100km: null },
    { label: 'Bateau', value: 'BATEAU', mission_rent_id: null, rent_upfuel: null, rent_amount: null, rent_paiement: null, rent_conso_100km: null },
  ]);
  const [viewDialog, setViewDialog] = useState({ open: false, destination: null, index: null, editable: false });
  const tableColumnsCount = 25;

  const showResult = (type, message, redirect = false) => {
    setResultDialog({ open: true, type, message, redirect });
  };

  const setMessage = ({ color, messageInfo }) => {
    showResult(color === 'green' ? 'success' : 'error', messageInfo);
  };

  const closeResultDialog = () => {
    const shouldRedirect = resultDialog.redirect;
    setResultDialog({ open: false, type: '', message: '', redirect: false });
    if (shouldRedirect) {
      navigate('/mission/decompte');
    }
  };

  const handleCloseRemoveDialog = () => {
    setRemoveDialog({
      open: false,
      agenda_id: null,
      mission_destination_id: null,
      mission_timesheet_destination_id: null,
    });
  };


  const isLoadingData = loadingBackdrop && destinations.length === 0;

  const fetchMission = async () => {
    try {
      setLoadingBackdrop(true);
      const response = await MissionSummaryService.getMissionData(mission_planning_id, agenda_id);
      if(response && response.status){
        setMission(response.data);
        setAgendas(response.data.agendas || []);
        setMissionnaries(response.data.missionnaries || []);
      }
    }
    catch (error) {
      console.error("Error fetching mission data:", error);
    }
    finally {
      setLoadingBackdrop(false);
    }
  };

  const mapDestinationRows = (destinationsResult = []) =>
    destinationsResult.map((dest, index) => ({
      index,
      ...dest,
      transport_type_source: dest.transport_type || null,
      transport_type_defaulted: !dest.mission_rent_id && !dest.transport_type,
      transport_type: dest.mission_rent_id ? dest.rent_type : dest.transport_type || 'FID',
      night_number: dest.night_number ?? (index === destinationsResult.length - 1 ? 0 : countNightsMission(
              index > 0 ? destinationsResult[index - 1].date_end : null,
              dest.date_begin,
              dest.date_end
            )),
      km_depart: dest.km_depart ?? '',
      km_arrivee: dest.km_arrivee ?? '',
      between_site_start_hour: dest.activite == 'mis' ? (dest.between_site_start_hour || dest.heure_begin) : '',
      between_site_end_hour: dest.between_site_end_hour || '',
      on_site_arrivee_hour: dest.activite !== 'mis' ? (dest.on_site_arrivee_hour || "08:00") : '',
      on_site_depart_hour: dest.on_site_depart_hour || dest.heure_end || '',
      distance_parcourue: computeDistanceParcourue(dest),
    }));

   const fetchTransportMeans = async () => {
          try {
              const result = await MissionRentService.getRentsByAgendaId(agenda_id);
              if(!result || !result.status) {
                  console.error("Error fetching transport:", result ? result.message : 'Unknown error');
                  return;
              }
            const rentsResult = result.data;
              setTransportMeans(prev => {
                const transportOptions = rentsResult.map(rent => ({
                  label: rent.rent_type,
                  value: rent.rent_type,
                  mission_rent_id: rent.mission_rent_id,
                  rent_upfuel: rent.rent_upfuel,
                  rent_amount: rent.rent_amount,
                  rent_paiement: rent.rent_paiement,
                  rent_conso_100km: rent.rent_conso_100km,
                }));
                return [  ...prev, ...transportOptions ];
            });


          } catch (error) {
              console.error("Error fetching transport:", error);
          }
  };

  const fetchTransportsMissions = async (missionId, currentAgendaId) => {
    if (!missionId || !currentAgendaId) {
      setTransports([]);
      return [];
    }
    try {
      const response = await MissionTransportService.transportsByMissionPlanning(missionId, currentAgendaId);
      const transportRows = response && response.status ? (response.data || []) : [];
      setTransports(transportRows);
      return transportRows;
    } catch (error) {
      console.error("Error fetching mission transports:", error);
      setTransports([]);
      return [];
    }
  };

  const fetchDestinationsByTransports = async (transportRows = []) => {
    setLoadingBackdrop(true);
    try {
      const validTransports = (Array.isArray(transportRows) ? transportRows : [])
        .filter((transport) => normalizeTransportId(transport?.transport_id));

      const transportDestinationsResults = await Promise.all(
        validTransports.map(async (transport) => {
          const response = await DecompteMissionService.retrieveDestinationsDecompte(
            mission_planning_id,
            agenda_id,
            timesheet_id,
            transport.transport_id,
            decompteId
          );
          return {
            transport_id: normalizeTransportId(transport.transport_id),
            destinations: response && response.status ? (response.data || []) : [],
          };
        })
      );

      const allDestinationsResponse = await DecompteMissionService.retrieveDestinationsDecompte(
        mission_planning_id,
        agenda_id,
        timesheet_id,
        null,
        decompteId
      );
      const allDestinations = allDestinationsResponse && allDestinationsResponse.status
        ? (allDestinationsResponse.data || [])
        : [];
      const destinationsWithTransport = allDestinations.filter(
        (destination) => !isWithoutTransport(destination)
      );
      const destinationsWithoutTransport = allDestinations.filter((destination) => isWithoutTransport(destination));

      const mergedDestinations = [];
      const seenKeys = new Set();
      const pushUniqueRows = (rows, prefix = 'rows', fallbackTransportId = null) => {
        rows.forEach((row, rowIndex) => {
          const normalizedRowTransportId =
            normalizeTransportId(row?.transport_id) ||
            getPrimaryTransportIdFromDestination(row);
          const normalizedFallbackTransportId = normalizeTransportId(fallbackTransportId);
          const transportIdToUse = normalizedRowTransportId ?? normalizedFallbackTransportId;
          const rowWithTransport = {
            ...row,
            transport_id: transportIdToUse,
          };
          const key = `${prefix}:${buildDestinationUniqueKey(rowWithTransport, rowIndex)}`;
          if (seenKeys.has(key)) {
            return;
          }
          seenKeys.add(key);
          mergedDestinations.push(rowWithTransport);
        });
      };

      transportDestinationsResults.forEach((entry) => {
        pushUniqueRows(
          entry.destinations || [],
          `transport_${entry.transport_id || 0}`,
          entry.transport_id
        );
      });
      destinationsWithTransport.forEach((destination) => {
        const transportIds = getTransportIdsFromDestination(destination);
        transportIds.forEach((currentTransportId) => {
          pushUniqueRows(
            [destination],
            `transport_${currentTransportId}`,
            currentTransportId
          );
        });
      });
      pushUniqueRows(destinationsWithoutTransport, 'without_transport');

      const mappedDestinations = mapDestinationRows(mergedDestinations);
      setDestinations(syncKmDepartChain(mappedDestinations));
    } catch (error) {
      console.error("Error fetching decompte destinations by transport:", error);
      setDestinations([]);
    } finally {
      setLoadingBackdrop(false);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await fetchMission();
      await fetchTransportMeans();
      const transportRows = await fetchTransportsMissions(mission_planning_id, agenda_id);
      await fetchDestinationsByTransports(transportRows);
    };

    if (mission_planning_id && agenda_id) {
      initialize();
    }
  }, [mission_planning_id, agenda_id, timesheet_id, decompteId]);


  const handleChangeFormValues = (field, value, index) => {
    if(field === 'transport_type') {
      const transport_value = value?.value ?? '';
      const mission_rent_id = value?.mission_rent_id || null;


      setDestinations((prev) => {
        const updated = [...prev];
        const currentEntry = { ...(updated[index] || {}) };
        const currentKm = Number(currentEntry.distance_km) || 0;
        const rentDetails = mission_rent_id ? transportMeans.find(t => t.mission_rent_id === mission_rent_id) : null;
        const rentConso = rentDetails?.rent_conso_100km || 0;
        const rentUpFuel = rentDetails?.rent_upfuel || 0;
        const mission_timesheet_details_consumption = mission_rent_id && rentConso ? currentKm / rentConso : 0;
        const mission_timesheet_details_amount = mission_rent_id ? mission_timesheet_details_consumption * rentUpFuel : 0;


        updated[index] = {
          ...currentEntry,
          mission_rent_id: mission_rent_id,
          transport_type_defaulted: false,
          [field]: transport_value,
          mission_timesheet_details_consumption,
          mission_timesheet_details_amount,
        };
        return syncKmDepartChain(updated);
      });
      return;
    }


    setDestinations((prev) => {
      const updated = [...prev];
      const currentEntry = { ...(updated[index] || {}) };


      if (field === 'km_depart') {
        currentEntry.km_depart = value;
        currentEntry.distance_parcourue = computeDistanceParcourue({
          ...currentEntry,
          km_depart: value
        });
      } else {
        currentEntry[field] = value;
        if (field === 'km_arrivee') {
          const start = parseFloat(currentEntry.km_depart) || 0;
          const end = parseFloat(value) || 0;
          currentEntry.distance_parcourue = Math.max(end - start, 0);
        }
      }

      if (['between_site_start_hour', 'between_site_end_hour', 'heure_begin', 'heure_end'].includes(field)) {
        currentEntry.between_site_duration_min = computeTravelDuration({ ...currentEntry });
      }

      if (['on_site_arrivee_hour', 'on_site_depart_hour'].includes(field)) {
        currentEntry.on_site_duration_min = computeOnSiteDuration(index, { ...currentEntry });
      }

      if (currentEntry.mission_rent_id !== null && currentEntry.mission_rent_id !== undefined) {
        const rent_upfuel = transportMeans.find(t => t.mission_rent_id === currentEntry.mission_rent_id)?.rent_upfuel || 0;
        if (field === 'mission_timesheet_details_consumption') {
          currentEntry.mission_timesheet_details_amount =  rent_upfuel * value;
        } else if (field === 'mission_timesheet_details_amount') {
          currentEntry.mission_timesheet_details_consumption = rent_upfuel ? value / rent_upfuel : 0;
        }
      }
      updated[index] = currentEntry;
      return syncKmDepartChain(updated);
    });
  };


  const handleAddDestination = () => {
    const routeTransportId = normalizeTransportId(transport_id);
    const initialTransportId = transports.some(
      (transport) => normalizeTransportId(transport.transport_id) === routeTransportId
    ) ? routeTransportId : null;

    const today = new Date().toISOString().slice(0, 10);
    setViewDialog({
      open: true,
      destination: {
        client_row_id: `manual-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        is_manual: true,
        mission_decompte_detail_id: null,
        mission_destination_id: null,
        mission_timesheet_destination_id: null,
        mission_timesheet_id: null,
        mission_planning_agenda_id: agenda_id || null,
        transport_id: initialTransportId,
        type: 'DM',
        date_begin: today,
        date_end: today,
        index: null,
      },
      index: null,
      editable: true,
    });
  };


  const getLocationFieldKey = (type, level) => {
    const fields = {
      depart: {
        region: 'region_depart',
        district: 'district_depart',
        commune: 'commune_depart',
        fokontany: 'fokontany_depart',
      },
      arrivee: {
        region: 'region_arrivee',
        district: 'district_arrivee',
        commune: 'commune_arrivee',
        fokontany: 'fokontany_arrivee',
      },
    };
    return fields[type][level];
  };


  const handleSave = async (action) => {
    if (hasArrivalBeforeDepart()) {
      showResult('error', "Le kilométrage d'arrivée est inférieur au départ sur au moins une ligne.");
      return;
    }
    setLoadingBackdrop(true);
    setDisabled(true);
   
    try {
    const decomptePayload = {
      mission_planning_id: mission?.mission_planning_id || null,
      mission_planning_agenda_id: agenda_id || null,
      mission_timesheet_id: timesheet_id,
      transport_id: normalizeTransportId(transport_id),
      decompte_id: decompteId,
      details: destinations.map((item, idx) => ({
        mission_decompte_detail_id: item.mission_decompte_detail_id || null,
        mission_destination_id: item.mission_destination_id || null,
        mission_timesheet_destination_id: item.mission_timesheet_destination_id || null,
        mission_planning_agenda_id: item.mission_planning_agenda_id ?? agenda_id ?? null,
        mission_timesheet_id: item.mission_timesheet_id ?? null,
        transport_id: item.transport_id ?? normalizeTransportId(transport_id),
        date_begin: normalizeDateForPayload(item.date_begin),
        date_end: normalizeDateForPayload(item.date_end),
        heure_begin: item.heure_begin || null,
        heure_end: item.heure_end || null,
        region_depart: item.region_depart ?? null,
        district_depart: item.district_depart ?? null,
        commune_depart: item.commune_depart ?? null,
        fokontany_depart: item.fokontany_depart ?? null,
        lieu_depart: item.lieu_depart ?? null,
        region_arrivee: item.region_arrivee ?? null,
        district_arrivee: item.district_arrivee ?? null,
        commune_arrivee: item.commune_arrivee ?? null,
        fokontany_arrivee: item.fokontany_arrivee ?? null,
        lieu_arrivee: item.lieu_arrivee ?? null,
        type: item.type ?? null,
        activite: item.activite ?? null,
        id_financement_mis: item.id_financement_mis ?? null,
        code_financement_mis: item.code_financement_mis ?? null,
        transport_type: item.transport_type ?? null,
        mission_rent_id: item.mission_rent_id ?? null,
        distance_km: item.distance_km ?? null,
        km_depart: item.km_depart ?? null,
        km_arrivee: item.km_arrivee ?? null,
        distance_reel: computeDistanceParcourue(item),
        between_site_start_hour: item.between_site_start_hour || null,
        between_site_end_hour: item.between_site_end_hour || null,
        between_site_duration_min: computeTravelDuration(item),
        on_site_arrivee_hour: item.on_site_arrivee_hour || null,
        on_site_depart_hour: item.on_site_depart_hour || null,
        on_site_duration_min: computeOnSiteDuration(idx, item),
      }))
    };


    const decompteResult = await DecompteMissionService.saveDecompte(decomptePayload);
    if(!decompteResult || !decompteResult.status){
      showResult('error', decompteResult?.message || "Une erreur est survenue lors de l'enregistrement du décompte.");
      setDisabled(false);
      return;
    }


    const missionDecompteId =
      decompteResult?.data?.mission_decompte_id ||
      decompteResult?.mission_decompte_id;

    if (!missionDecompteId) {
      showResult('error', "L'identifiant du décompte enregistré est introuvable.");
      return;
    }

    if(action === 'save'){
      showResult('success', 'Le décompte a été enregistré avec succès.', true);
    }
    if(action === 'send'){
        setConfirmDialog({
          open: true,
          mission_planning_id: mission_planning_id || null,
          agenda_id: agenda_id || null,
          timesheet_id: timesheet_id || null,
          transport_id: transport_id || null,
          mission_decompte_id: missionDecompteId,
        });
    }


    } catch (error) {
      showResult('error', error.message || "Une erreur est survenue lors de l'enregistrement du décompte.");
    }
    finally {
      setLoadingBackdrop(false);
      setDisabled(false);
    }
  };


  const handleOpenDestinationView = (destination, index = null, editable = false) => {
    if (!destination) {
      return;
    }
    setViewDialog({
      open: true,
      destination: {
        ...destination,
        index: index ?? destination?.index ?? null
      },
      index,
      editable
    });
  };

  const handleKmDepartBlur = (index) => {
    setDestinations((prev) => {
      const updated = [...prev];
      const currentEntry = { ...(updated[index] || {}) };
      const start = parseFloat(currentEntry.km_depart);
      const estimatedDistance = parseFloat(currentEntry.distance_km);

      if (Number.isNaN(start) || Number.isNaN(estimatedDistance)) {
        return syncKmDepartChain(updated);
      }

      const autoArrival = start + estimatedDistance;
      currentEntry.km_arrivee = autoArrival;
      currentEntry.distance_parcourue = Math.max(estimatedDistance, 0);
      updated[index] = currentEntry;

      return propagateEstimatedKmChain(updated, index + 1);
    });
  };

  const handleKmArriveeBlur = (index) => {
    setDestinations((prev) => {
      const updated = [...prev];
      const currentEntry = { ...(updated[index] || {}) };
      currentEntry.distance_parcourue = computeDistanceParcourue(currentEntry);
      updated[index] = currentEntry;

      return propagateEstimatedKmChain(updated, index + 1);
    });
  };


  const handleCloseDestinationView = () => {
    setViewDialog({ open: false, destination: null, index: null, editable: false });
  };

  const handleSaveDestinationEdit = (updatedDestination) => {
    const selectedTransportId = normalizeTransportId(updatedDestination?.transport_id);
    const isExistingMissionTransport = transports.some(
      (transport) => normalizeTransportId(transport.transport_id) === selectedTransportId
    );
    if (!selectedTransportId || !isExistingMissionTransport) {
      showResult('error', 'Veuillez sélectionner un transport existant de la mission avant d’ajouter la ligne.');
      return;
    }
    const rowIndex = viewDialog.index ?? updatedDestination?.index;
    setDestinations((previous) => {
      const nextDestinations = Number.isInteger(rowIndex) && rowIndex >= 0
        ? previous.map((destination, index) =>
          index === rowIndex ? { ...destination, ...updatedDestination } : destination
        )
        : [...previous, { ...updatedDestination, index: undefined }];
      return syncKmDepartChain(nextDestinations);
    });
    handleCloseDestinationView();
  };


  const handleSendDecompte = async () => {
    setSendLoading(true);
    setSendDisabled(true);
    try{
      const resp = await DecompteMissionService.sendAndGenerate(confirmDialog.mission_planning_id, confirmDialog.agenda_id, confirmDialog.timesheet_id, confirmDialog.transport_id, confirmDialog.mission_decompte_id);
      if(resp && resp.status){
        showResult('success', 'Le décompte a été envoyé avec succès.', true);
        setConfirmDialog({ open: false, mission_planning_id: null, agenda_id: null, timesheet_id: null, transport_id: null, mission_decompte_id: null });
      } else {
        showResult('error', resp?.message || "Une erreur est survenue lors de l'envoi du décompte.");
      }
    }catch(error){
      showResult('error', error.message || "Une erreur est survenue lors de l'envoi du décompte.");
    }finally{
      setSendLoading(false);
      setSendDisabled(false);
    }
  };


  const getLocationLabel = (entry, destination, type, level) => {
    const key = getLocationFieldKey(type, level);
    return entry?.[key] || destination?.[key] || '-';
  };


  const computeDistanceParcourue = (dest = {}) => {
    const depart = parseFloat(dest.km_depart) || 0;
    const arrivee = parseFloat(dest.km_arrivee) || 0;
    const diff = arrivee - depart;
    return diff >= 0 ? diff : 0;
  };

  const propagateEstimatedKmChain = (entries = [], startIndex = 1) => {
    if (!Array.isArray(entries)) {
      return entries;
    }

    const propagated = entries.map((entry) => ({ ...entry }));
    for (let i = Math.max(startIndex, 1); i < propagated.length; i++) {
      const prevArrivee = propagated[i - 1]?.km_arrivee ?? '';
      propagated[i].km_depart = prevArrivee;

      const start = parseFloat(prevArrivee);
      const estimatedDistance = parseFloat(propagated[i].distance_km);

      if (Number.isNaN(start) || Number.isNaN(estimatedDistance)) {
        propagated[i].km_arrivee = '';
        propagated[i].distance_parcourue = 0;
      } else {
        propagated[i].km_arrivee = start + estimatedDistance;
        propagated[i].distance_parcourue = Math.max(estimatedDistance, 0);
      }

      propagated[i].between_site_duration_min = computeTravelDuration(propagated[i]);
      propagated[i].on_site_duration_min = computeOnSiteDuration(i, propagated[i]);
    }

    return propagated;
  };

  const syncKmDepartChain = (entries) => {
    if (!Array.isArray(entries)) {
      return entries;
    }
    const synced = entries.map((entry) => ({ ...entry }));
    for (let i = 1; i < synced.length; i++) {
      const prevArrivee = synced[i - 1]?.km_arrivee ?? '';
      synced[i].km_depart = prevArrivee;
    }
    return synced.map((entry, index) => ({
      ...entry,
      distance_parcourue: computeDistanceParcourue(entry),
      between_site_duration_min: computeTravelDuration(entry),
      on_site_duration_min: computeOnSiteDuration(index, entry),
    }));
  };

  const hasArrivalBeforeDepart = () =>
    destinations.some(dest => {
      const depart = parseFloat(dest.km_depart);
      const arrivee = parseFloat(dest.km_arrivee);
      return !Number.isNaN(depart) && !Number.isNaN(arrivee) && arrivee < depart;
    });

  const isEndBeforeStart = (startTime, endTime, startDate, endDate) => {
    const start = toDateTime(startDate, startTime);
    const end = toDateTime(endDate, endTime);
    return start && end && end < start;
  };

  const hasInvalidTimeOrder = () =>
    destinations.some(dest =>
      isEndBeforeStart(
        extractTime(dest.between_site_start_hour || dest.heure_begin),
        extractTime(dest.between_site_end_hour || dest.heure_end),
        dest.date_begin,
        dest.date_end
      ) ||
      isEndBeforeStart(
        extractTime(dest.on_site_arrivee_hour || dest.heure_end),
        extractTime(dest.on_site_depart_hour || dest.heure_end),
        dest.date_begin,
        dest.date_end
      )
    );

  const destinationGroups = useMemo(() => {
    const transportById = new Map();
    const transportOrder = [];

    transports.forEach((transport) => {
      const currentTransportId = normalizeTransportId(transport?.transport_id);
      if (!currentTransportId || transportById.has(currentTransportId)) {
        return;
      }
      transportById.set(currentTransportId, transport);
      transportOrder.push(currentTransportId);
    });

    const groupedByTransportId = new Map();
    const withoutTransportRows = [];

    destinations.forEach((destination, index) => {
      const currentTransportId = getPrimaryTransportIdFromDestination(destination);
      if (!currentTransportId) {
        withoutTransportRows.push({ destination, index });
        return;
      }
      if (!groupedByTransportId.has(currentTransportId)) {
        groupedByTransportId.set(currentTransportId, []);
      }
      groupedByTransportId.get(currentTransportId).push({ destination, index });
    });

    groupedByTransportId.forEach((_, currentTransportId) => {
      if (!transportById.has(currentTransportId)) {
        transportOrder.push(currentTransportId);
      }
    });

    const buildTransportLabel = (currentTransportId) => {
      const transport = transportById.get(currentTransportId);
      if (!transport) {
        return `Transport ${currentTransportId}`;
      }
      const modeLabel = transport?.mission_rent_id
        ? (transport?.rent_type || 'Location')
        : 'Voiture';
      const referenceLabel =
        transport?.vhc_imm ||
        transport?.rent_type ||
        `Transport ${currentTransportId}`;
      return `${modeLabel} - ${referenceLabel}`;
    };

    const groups = transportOrder
      .filter((currentTransportId) => groupedByTransportId.has(currentTransportId))
      .map((currentTransportId) => ({
        key: `transport_${currentTransportId}`,
        label: buildTransportLabel(currentTransportId),
        transport: transportById.get(currentTransportId) || { transport_id: currentTransportId },
        rows: groupedByTransportId.get(currentTransportId) || [],
      }));

    if (withoutTransportRows.length > 0) {
      groups.push({
        key: 'without_transport',
        label: 'Sans transport',
        transport: null,
        rows: withoutTransportRows,
      });
    }

    return groups;
  }, [destinations, transports]);


  const toDateTime = (date, time) => {
    if (!date) return null;
    let dateStr = date;
    if (date instanceof Date && !Number.isNaN(date.getTime())) {
      dateStr = date.toISOString().split('T')[0];
    } else if (typeof date === 'string') {
      const trimmed = date.trim();
      dateStr = trimmed.split('T')[0].split(' ')[0];
    } else {
      return null;
    }

    const timeStr = extractTime(time) || '00:00';
    const candidates = [
      `${dateStr}T${timeStr}`,
      `${dateStr} ${timeStr}`
    ];

    for (const candidate of candidates) {
      const dt = new Date(candidate);
      if (!Number.isNaN(dt.getTime())) {
        return dt;
      }
    }
    return null;
  };

  const extractTime = (raw) => {
    if (!raw) return '';
    if (raw.length === 5) return raw; // already HH:MM
    const match = `${raw}`.match(/(\d{2}):(\d{2})/);
    return match ? `${match[1]}:${match[2]}` : '';
  };

  const diffMinutes = (start, end) => {
    if (!start || !end) return 0;
    const diffMs = end.getTime() - start.getTime();
    return diffMs > 0 ? Math.round(diffMs / 60000) : 0;
  };


  const computeTravelDuration = (dest = {}) => {
    const startTime = extractTime(dest.between_site_start_hour || dest.heure_begin);
    const endTime = extractTime(dest.between_site_end_hour || dest.heure_end);
    const start = toDateTime(dest.date_begin, startTime);
    const end = toDateTime(dest.date_end, endTime);
    return diffMinutes(start, end);
  };


  const computeOnSiteDuration = (index, override = null) => {
    const current = override || destinations[index];
    if (!current) return 0;
    const arriveeTime = extractTime(current.on_site_arrivee_hour || current.heure_end);
    const departTime = extractTime(current.on_site_depart_hour || current.heure_end);
    const arrivee = toDateTime(current.date_begin, arriveeTime);
    const depart = toDateTime(current.date_end, departTime);
    return diffMinutes(arrivee, depart);
  };


    return (
       <MainContainer {...headerDataMission}>
            <Dialog
            open={true}
            fullScreen
            aria-labelledby="form-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.dialog}
      >
        <DialogTitle id="form-dialog-title" sx={{ fontWeight: 700, textAlign: 'left', color: '#0f4c81' }}>
          Décompte réel de la mission — {mission?.reference_mission || mission?.reference || 'Référence indisponible'}
        </DialogTitle>
        <DialogContent dividers sx={{ overflowX: 'hidden' }}>
        <DialogContentText sx={{ fontSize: '12px', color: '#8e9194ff', display: 'block', width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
              <LoadingSimpleBackdrop openLoadingSimpleBackdrop={loadingBackdrop} />
                <Box sx={{ '& .MuiTextField-root': { mb: 0.5 }, '& .MuiTableCell-root': { py: 0.5, fontSize: '0.78rem' } }}>
                  <MissionData mission={mission} />
                </Box>
                <Alert severity="info" sx={{ mt: 1.5, mb: 1.5, fontSize: '0.8rem' }}>
                  Vérifiez les départs, arrivées, heures et relevés kilométriques avant l’enregistrement. Les destinations ajoutées restent propres à ce décompte.
                </Alert>
                      {
                        agendas.length !==0 ? (
                      agendas.map((agenda, index) => (
                 <fieldset className={classes.fieldset} key={agenda.mission_planning_agenda_id}>
                        <legend>
                          &nbsp;&nbsp;
                          {`Agenda ${ agendas?.length > 1 ? (agendas[index].mission_planning_destination_id != null ? 'mission ' + (index + 1) : (index + 1)) : ''} : ${agenda.reference}`}
                          &nbsp; &nbsp;
                        </legend>
                          <TabContext value={value}>
                      <TabPanel value="1" sx={{ p: 0, pt: 2, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                        <Box display="flex" mb={2} justifyContent="flex-start">
                          <Button color='info' variant="contained" startIcon={<AddIcon />} size="small" onClick={handleAddDestination}>
                            Ajouter une ligne
                          </Button>
                        </Box>
                        <Grid container spacing={2} >
                          </Grid>
                        {hasArrivalBeforeDepart() && (
                          <Alert severity="error" sx={{ mt: 1, fontSize: '12px' }}>
                            Le kilometrage d'arrivee est inferieur au depart sur au moins une ligne.
                          </Alert>
                        )}
                        <TableContainer sx={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', maxHeight: '64vh', overflow: 'auto', border: '1px solid #d7e3ee', borderRadius: 2, boxShadow: '0 4px 14px rgba(15, 76, 129, 0.08)' }}>
                          <Table stickyHeader sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                            {/* //////////// Table Header //////////// */}
                              <TableRow sx={{ '& .MuiTableCell-root': { backgroundColor: '#eff6ff', color: '#0f4c81', fontWeight: 700, borderColor: '#c9d9e8' } }}>
                                    <TableCell rowSpan={2} sx={{ minWidth: '40px', textAlign: "center" }}></TableCell>
                                    <TableCell rowSpan={2} sx={{ maxWidth: '100px', textAlign: "center" }}>Date(s)</TableCell>
                                    <TableCell colSpan={5} sx={{ minWidth: '210px', textAlign: "center"}}>Lieu de départ</TableCell>
                                    <TableCell colSpan={5} sx={{ minWidth: '210px', textAlign: "center"}}>Lieu d'arrivée</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '60px', textAlign: "center"}}>Type</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '60px', textAlign: "center"}}>Financement</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '240px', textAlign: "center" }}>Moyen de transport <Bullred/></TableCell>
                                    <TableCell colSpan={2} sx={{ minWidth: '60px', textAlign: "center" }}>Odomètre</TableCell>
                                    <TableCell colSpan={2} sx={{ minWidth: '60px', textAlign: 'center'}}>Distance Parcourue</TableCell>
                                    <TableCell colSpan={3} sx={{ minWidth: '130px', textAlign: "center" }}>Temps passé entre deux sites</TableCell>
                                    <TableCell colSpan={3} sx={{ minWidth: '130px', textAlign: "center" }}>Temps passé sur Site / Bureau</TableCell>
                                   
                              </TableRow>
                              <TableRow sx={{ '& .MuiTableCell-root': { backgroundColor: '#eff6ff', color: '#0f4c81', fontWeight: 700, borderColor: '#c9d9e8' } }}>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}>Région </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>District </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Commune </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center"}}>Fokontany </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Lieu</TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}>Région </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>District </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Commune </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Fokontany</TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Lieu</TableCell>
                                    <TableCell sx={{ minWidth: '140px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}>Départ <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '140px', textAlign: "center" }}>Arrivée <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '60px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}> Prévisionnelle</TableCell>
                                    <TableCell sx={{ minWidth: '60px'}}>Réelle </TableCell>
                                    <TableCell sx={{ minWidth: '150px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}>Heure Départ </TableCell>
                                    <TableCell sx={{ minWidth: '150px', textAlign: "center" }}>Heure Arrivée </TableCell>
                                    <TableCell sx={{ minWidth: '150px', textAlign: "center" }}>Durée en mn</TableCell>
                                    <TableCell sx={{ minWidth: '150px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff"  }}>Heure Arrivée <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '150px', textAlign: "center" }}>Heure Départ <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '150px', textAlign: "center" }}>Durée en mn</TableCell>  
                              </TableRow>
                              {/* ///////////////////////////Corps de la table */}
                <TableBody  sx={{
                    "& .MuiTableCell-body": {
                      fontSize: "12px",
                      borderColor: '#e7eef5',
                    },
                  }}>
                    {isLoadingData ? (
                      Array.from({ length: 3 }).map((_, skeletonIndex) => (
                        <TableRow key={`skeleton-${skeletonIndex}`}>
                          {Array.from({ length: 20 }).map((__, cellIndex) => (
                            <TableCell key={`skeleton-cell-${skeletonIndex}-${cellIndex}`}>
                              <Skeleton variant="rectangular" height={24} />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    ) : (
                    destinationGroups.map((group) => (
                      <React.Fragment key={group.key}>
                        <TableRow sx={{ backgroundColor: "#e5f0f8" }}>
                          <TableCell colSpan={tableColumnsCount} sx={{ fontWeight: 600, py: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 2 }}>
                              <Box>
                                <Typography sx={{ color: '#0f4c81', fontWeight: 800, fontSize: '0.9rem' }}>{group.label}</Typography>
                                {group.transport?.driver_name && <Typography variant="caption" color="text.secondary">Chauffeur : {group.transport.driver_name}</Typography>}
                                {group.transport && (
                                  <Box sx={{ mt: 0.5 }}>
                                    <Button size="small" variant="outlined" color="info" startIcon={<InfoOutlinedIcon />} onClick={() => setTransportDetailDialog({ open: true, transport: group.transport })}>
                                      Détails
                                    </Button>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                    {group.rows.map(({ destination: dest, index }) => {
                      const rowEntry = dest || {};
                      return (
                      <TableRow key={buildDestinationUniqueKey(dest, index)}
                              sx={{
                                "&:nth-of-type(odd)": {
                                  backgroundColor: "#ffffffdb",
                                },
                                "&:hover": {
                                  backgroundColor: "#f3f7fbeb",
                                },
                              }}>
                        <TableCell sx={{ minWidth: '40px', textAlign: "center" }}>
                                                      <IconButton
                                                        aria-label="modifier la ligne"
                                                        size="small"
                                                        color="info"
                                                        onClick={() => handleOpenDestinationView(dest, index, true)}
                                                      >
                                                        <EditIcon fontSize="inherit" />
                                                      </IconButton>
                                                      <IconButton aria-label="delete" size="small" color="error"
                                                       onClick={() => setRemoveDialog({ open: true, agenda_id: agenda.mission_planning_agenda_id,
                                                      mission_destination_id: dest.mission_destination_id || null, 
                                                       mission_timesheet_destination_id: dest.mission_timesheet_destination_id || null })}
                                                       >
                                                      <CloseIcon fontSize="inherit" />
                                                    </IconButton>
                        </TableCell>
                        <TableCell sx={{ maxWidth: '100px'}}>{formatDate(dest.date_begin) == formatDate(dest.date_end) ? formatDate(dest.date_begin) : (formatDate(dest.date_begin) + " - " + formatDate(dest.date_end))}</TableCell>
                        <TableCell sx={{ maxWidth: '120px', borderLeft: "1px solid #c8c8c8ff", py: 0.5 }}>
                        {getLocationLabel(rowEntry, dest, 'depart', 'region')}
                        </TableCell>
                        <TableCell sx={{ maxWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'depart', 'district')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'depart', 'commune')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'depart', 'fokontany')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center" }}>{dest.lieu_depart || dest.direction_location || '-'}</TableCell>
                        <TableCell sx={{ minWidth: '120px', borderLeft: "1px solid #c8c8c8ff", py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'region')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'district')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'commune')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'fokontany')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '140px', textAlign: "center" }}>{dest.lieu_arrivee || dest.direction_location || '-'}</TableCell>
                        <TableCell sx={{ borderLeft: "1px solid #e6e6e6"}}>{dest.type === "DM" ? <Chip icon={<CardTravelIcon />} label="Mission" variant="outlined" /> : <Chip icon={<TimeToLeaveIcon />} style={{ fontSize: "12px" }} label="Délai de route" variant="outlined"/>}</TableCell>
                        <TableCell sx={{ minWidth: '80px', textAlign: "center" }}>
                          { dest.code_financement_mis}
                          </TableCell>
                          <TableCell sx={{ minWidth: '140px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}>
                          <Autocomplete
                            size="small"
                            options={transportMeans}
                            getOptionLabel={(option) => option.label || ''}
                            value={transportMeans.find(t => t.value === dest.transport_type) || null}
                            onChange={(event, newValue) => {
                              handleChangeFormValues('transport_type', newValue, index);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                sx={{ "& .MuiInputBase-input": { fontSize: "12px" } }}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell sx={{ minWidth: '140px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}>
                          <TextField
                            size="small"
                            type="number"
                            value={dest.km_depart ?? ''}
                            onChange={(e) => handleChangeFormValues('km_depart', e.target.value, index)}
                            onBlur={() => handleKmDepartBlur(index)}
                            sx={{ "& .MuiInputBase-input": { fontSize: "12px" } }}
                          />
                        </TableCell>
                        <TableCell sx={{ minWidth: '140px', textAlign: "center" }}>
                          <TextField
                            size="small"
                            type="number"
                            value={dest.km_arrivee ?? ''}
                            onChange={(e) => handleChangeFormValues('km_arrivee', e.target.value, index)}
                            onBlur={() => handleKmArriveeBlur(index)}
                            sx={{ "& .MuiInputBase-input": { fontSize: "12px" } }}
                          />
                        </TableCell>
                        <TableCell sx={{minWidth: '140px', borderLeft: "1px solid #c8c8c8ff"}}>
                           {dest?.distance_km || ""} km
                        </TableCell>
                        <TableCell sx={{ minWidth: '80px', textAlign: "center" }}>
                          <label>{computeDistanceParcourue(dest)}</label> km
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff" }}>
                         <TextField
                            size="small"
                            type="time"
                            value={dest?.between_site_start_hour || ''}
                            onChange={(e) => handleChangeFormValues('between_site_start_hour', e.target.value, index)}
                            sx={{ "& .MuiInputBase-input": { fontSize: "12px" } }}
                          />
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center" }}>
                          <TextField
                            size="small"
                            type="time"
                            value={dest.between_site_end_hour ||  ''}
                            onChange={(e) => handleChangeFormValues('between_site_end_hour', e.target.value, index)}
                            sx={{ "& .MuiInputBase-input": { fontSize: "12px" } }}
                          />
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center"}}>
                          {dest.between_site_duration_min || 0}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center", borderLeft: "1px solid #c8c8c8ff"  }}>
                          <TextField
                            size="small"
                            type="time"
                            value={dest.on_site_arrivee_hour || ''}
                            onChange={(e) => handleChangeFormValues('on_site_arrivee_hour', e.target.value, index)}
                            sx={{ "& .MuiInputBase-input": { fontSize: "12px" } }}
                          />
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center" }}>
                          <TextField
                            size="small"
                            type="time"
                            value={dest.on_site_depart_hour || ''}
                            onChange={(e) => handleChangeFormValues('on_site_depart_hour', e.target.value, index)}
                            sx={{ "& .MuiInputBase-input": { fontSize: "12px" } }}
                          />
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center" }}>
                          {dest.on_site_duration_min || 0}
                        </TableCell>
                      </TableRow>
                    );
                    })}
                      </React.Fragment>
                    ))
                  )}
                  </TableBody>
                          </Table>
                         </TableContainer>
                          {hasInvalidTimeOrder() && (
                            <Alert severity="error" sx={{ mt: 1, fontSize: '12px' }}>
                              Heure d'arriv&#233;e inf&#233;rieure &#224; l'heure de d&#233;part sur au moins une ligne (entre sites ou sur site).
                            </Alert>
                          )}
                          </TabPanel>
                      <TabPanel value="2">
                          <RentManagement setMessage={setMessage} setValue={setValue} setTransportMeans={setTransportMeans} mission_planning_agenda_id={agenda_id} />
                        </TabPanel>
                          </TabContext>
                  </fieldset>
                        ))) : (
                          <Alert severity="info" size="small" sx={{ marginTop: "1%", fontSize: "12px" }}>
                          Aucun agenda n'est associé à cette mission.
                      </Alert>
                        )
                      }
        </DialogContentText>


                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2, display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap', borderTop: '1px solid #e5edf5' }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Faites défiler le tableau horizontalement pour afficher toutes les colonnes.
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, flexWrap: 'wrap' }}>
                    <Button variant="outlined" color="error" onClick={() => navigate("/mission/decompte")} disabled={disabled}>
                      Annuler
                    </Button>
                    <Button variant="outlined" color="info" startIcon={<SaveIcon />} onClick={() => handleSave('save')} disabled={disabled}>
                      Enregistrer
                    </Button>
                    <Button variant="contained" color="info" startIcon={<SendIcon />} onClick={() => handleSave('send')} disabled={disabled} sx={{ boxShadow: '0 4px 10px rgba(2, 132, 199, 0.25)' }}>
                      Enregistrer et envoyer
                    </Button>
                  </Box>
                </DialogActions>
            </Dialog>
           <DestinationViewDialog
             open={viewDialog.open}
             destination={viewDialog.destination}
             onClose={handleCloseDestinationView}
             editable={viewDialog.editable}
             onSave={handleSaveDestinationEdit}
             localOnly
             decompteMode
             transportOptions={transports}
             setMessage={setMessage}
           />
           <Dialog
             open={transportDetailDialog.open}
             onClose={() => setTransportDetailDialog({ open: false, transport: null })}
             fullWidth
             maxWidth="md"
           >
             <DialogTitle sx={{ color: '#0f4c81', fontWeight: 700 }}>Détails du transport</DialogTitle>
             <DialogContent dividers>
               {transportDetailDialog.transport && (
                 <>
                   <TransportData transport={transportDetailDialog.transport} />
                   {transportDetailDialog.transport.mission_rent_id && (
                     <Box sx={{ mt: 2, p: 2, borderRadius: 2, backgroundColor: '#f5f9fd' }}>
                       <Typography variant="subtitle2" sx={{ color: '#0f4c81', fontWeight: 700, mb: 0.5 }}>Location</Typography>
                       <Typography variant="body2">{transportDetailDialog.transport.rent_type || 'Location'}</Typography>
                       <Typography variant="body2">Tarif : {transportDetailDialog.transport.rent_amount ?? '—'} Ar</Typography>
                       <Typography variant="body2">Mode de paiement : {transportDetailDialog.transport.rent_paiement || '—'}</Typography>
                     </Box>
                   )}
                 </>
               )}
             </DialogContent>
             <DialogActions>
               <Button variant="outlined" onClick={() => setTransportDetailDialog({ open: false, transport: null })}>Fermer</Button>
             </DialogActions>
           </Dialog>
           <SuccesDialog
             open={resultDialog.open && resultDialog.type === 'success'}
             onClose={closeResultDialog}
             message={resultDialog.message}
           />
           <ErrorDialog
             open={resultDialog.open && resultDialog.type === 'error'}
             onClose={closeResultDialog}
             message={resultDialog.message}
           />
           <Dialog
             open={removeDialog.open}
             onClose={handleCloseRemoveDialog}
             aria-labelledby="decompte-remove-title"
             aria-describedby="decompte-remove-description"
             fullWidth
             maxWidth="sm"
           >
             <DialogTitle id="decompte-remove-title">
               {"Confirmation"}
             </DialogTitle>
             <DialogContent>
               <DialogContentText id="decompte-remove-description">
                 Voulez-vous vraiment retirer cette ligne de destination ?
               </DialogContentText>
             </DialogContent>
             <DialogActions>
               <Button onClick={handleCloseRemoveDialog} variant="contained" color="error">
                 Annuler
               </Button>
               <Button onClick={handleCloseRemoveDialog} variant="contained" color="info" autoFocus>
                 Supprimer
               </Button>
             </DialogActions>
           </Dialog>
           <Dialog
             open={confirmDialog.open}
              onClose={() => setConfirmDialog({ open: false, mission_planning_id: null, agenda_id: null, timesheet_id: null, transport_id: null, mission_decompte_id: null })}
              aria-labelledby="decompte-send-title"
              aria-describedby="decompte-send-description"
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                {"Confirmation d'envoi du decompte"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="decompte-send-description">
                  <LoadingSimpleBackdrop openLoadingSimpleBackdrop={sendLoading} />
                  <label>Souhaitez-vous confirmer l'envoi du decompte de la mission au responsable ?</label>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setConfirmDialog({ open: false, mission_planning_id: null, agenda_id: null, timesheet_id: null, transport_id: null, mission_decompte_id: null })} variant='contained' color='error' disabled={sendDisabled}>
                  Fermer
                </Button>
                <Button onClick={handleSendDecompte} autoFocus disabled={sendDisabled} variant='contained' color='info'>
                  Envoyer
                </Button>
              </DialogActions>
            </Dialog>
                       
        </MainContainer>
    );
}
export default DecompteAdd;







